import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#let (get @record @propertyName) as |kpiData|}}\n  {{#if kpiData}}\n    {{format-amount kpiData.value kpiData.unit}}\n  {{else}}\n    -\n  {{/if}}\n{{/let}}")